import React from 'react'
import {SidebarItem} from '../../utils/Sidebar';
import {Autorenew, Badge, Gavel, GroupAdd, Notifications, ReceiptLong, Security, SpaceDashboard, WorkspacePremium} from '@mui/icons-material';
import DashboardLayout from '../../utils/DashboardLayout';
import {Outlet} from 'react-router-dom';

const profileMenu: SidebarItem[] = [
  {labelKey: 'dashboard.profile.dashboard', to: '/profile/dashboard', icon: SpaceDashboard},
  {labelKey: 'dashboard.profile.premium', to: '/profile/premium', icon: WorkspacePremium},
  {labelKey: 'dashboard.profile.trades', to: '/profile/trades', icon: Autorenew},
  {labelKey: 'dashboard.profile.buyorder', to: '/profile/buy-order', icon: Gavel},
  {labelKey: 'dashboard.profile.transactions', to: '/profile/transactions', icon: ReceiptLong},
  {labelKey: 'dashboard.profile.connections', to: '/profile/connect-account', icon: GroupAdd},
  {labelKey: 'dashboard.profile.kyc', to: '/profile/kyc', icon: Badge},
  {labelKey: 'dashboard.profile.stripe_onboarding', to: '/profile/stripe-onboarding', icon: Badge},
  {labelKey: 'dashboard.profile.security', to: '/profile/security', icon: Security},
  {labelKey: 'dashboard.profile.notifications', to: '/profile/notifications', icon: Notifications},
];

const ProfileLayout = () => {

  return (
      <DashboardLayout titleKey="dashboard.profile.title" menuItems={profileMenu} isSystem={false}>
        <Outlet/>
      </DashboardLayout>
  )
}
export default ProfileLayout
